import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Map paths to readable page titles
const pageTitles = {
  '/': 'Landing',
  '/type': 'Type Selection',
  '/upload': 'Upload',
  '/analysis': 'Analysis',
  '/book-setup': 'Book Setup',
  '/preview': 'Preview',
};

/**
 * Hook to track page views on route changes
 * Must be used inside a Router context
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const title = pageTitles[location.pathname] || 'Unknown Page';
    trackPageView(location.pathname, title);
  }, [location]);
};

export default usePageTracking;


